import { Loader } from '@calendly/ui/components/loader'

import { LoadingStateContainer } from '../shared/styles'


export const ModalContentContainer = ({ isLoading, showPrompt, prompt, children }) => {
  if (isLoading) {
    return (
      <LoadingStateContainer>
        <Loader />
      </LoadingStateContainer>
    )
  }

  if (showPrompt) return prompt

  return children
}
